import {
	CYCLE_PURCHASE_VERIFICATION_BILLING_OVERVIEW_ROUTER,
	CYCLE_PURCHASE_BILLING_ROUTER,
	CYCLE_PURCHASE_OVERVIEW_ROUTER,
	CYCLE_PURCHASE_DETAIL_TAB_ROUTER,
	CYCLE_PURCHASE_CANCEL_OVERVIEW_ROUTER,
} from "@Router/routerPath";
import { FRONT_KEY } from "@Constants/frontKey";
import {
	CyclePurchaseBillingPage,
	CyclePurchaseVerificationBatchPaymentPage,
	CyclePurchaseCancelOverviewPage
} from "@Local/CyclePurchase/";
import { CyclePurchaseOverviewPage, CyclePurchaseDetailPage } from "@Local/CyclePurchase/";

const cyclePurchaseRouter = [
	{
		description: "循環訂單",
		frontKey: FRONT_KEY.CYCLE_PURCHASE,
	},
	{
		description: "檢核扣款總覽",
		frontKey: FRONT_KEY.CYCLE_PURCHASE_VERIFICATION_BILLING_OVERVIEW,
		static: true,
		path: CYCLE_PURCHASE_VERIFICATION_BILLING_OVERVIEW_ROUTER,
		href: CYCLE_PURCHASE_VERIFICATION_BILLING_OVERVIEW_ROUTER,
		as: CyclePurchaseVerificationBatchPaymentPage,
	},
	{
		description: "銀行扣款明細",
		frontKey: FRONT_KEY.CYCLE_PURCHASE_BILLING,
		static: true,
		path: CYCLE_PURCHASE_BILLING_ROUTER,
		as: CyclePurchaseBillingPage,
	},

	{
		description: "循環訂單總覽",
		frontKey: FRONT_KEY.CYCLE_PURCHASE_OVERVIEW,
		strict: true,
		path: CYCLE_PURCHASE_OVERVIEW_ROUTER,
		href: CYCLE_PURCHASE_OVERVIEW_ROUTER,
		as: CyclePurchaseOverviewPage,
	},
	{
		description: "循環訂單明細",
		frontKey: FRONT_KEY.CYCLE_PURCHASE_DETAIL,
		strict: true,
		path: CYCLE_PURCHASE_DETAIL_TAB_ROUTER,
		as: CyclePurchaseDetailPage,
	},
	{
		description: "退訂總覽",
		frontKey: FRONT_KEY.CYCLE_PURCHASE_CANCEL_OVERVIEW,
		strict: true,
		path: CYCLE_PURCHASE_CANCEL_OVERVIEW_ROUTER,
        href: CYCLE_PURCHASE_CANCEL_OVERVIEW_ROUTER,
		as: CyclePurchaseCancelOverviewPage,
	},
];

export default cyclePurchaseRouter;
